import React, { Fragment } from 'react';
import {
  withScriptjs,
  withGoogleMap,
} from 'react-google-maps';

import { getDisplayName } from '../../../../util/react';

function withPreloadCheck(WrappedComponent) {
  const AsyncGoogleMap = withScriptjs(withGoogleMap(props => (
    <WrappedComponent {...props} />
  )));

  const GoogleMap = withGoogleMap(props => (
    <WrappedComponent {...props} />
  ));

  class WithPreloadCheck extends React.Component {
    render() {
      return (
        <Fragment>
          {this.props.googleApiLoaded
            ?
              <GoogleMap {...this.props} />
            :
              <AsyncGoogleMap {...this.props} />
          }
        </Fragment>
      );
    }
  }


  WithPreloadCheck.displayName = `withPreloadCheck(${getDisplayName(WrappedComponent)})`;

  return WithPreloadCheck;
}

export default withPreloadCheck;
